import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Operators } from './operators';
import { BaseInfoService } from 'app/services/base-info.service';

@Component({
  selector: 'app-operator-list',
  templateUrl: './operator-list.component.html',
  styleUrls: ['./operator-list.component.scss']
})
export class OperatorListComponent implements OnInit, OnChanges {
  selectedOperator = { key: '' };
  operatorList: Operators[] = [];
  @Input() hasError;
  @Input() key;
  @Input() optional = false;
  @Output() operatorNameString: EventEmitter<any> = new EventEmitter();
  @Output() diableOperator: EventEmitter<any> = new EventEmitter();
  @Output() operatorLists: EventEmitter<any> = new EventEmitter();

  constructor(
    private baseInfo: BaseInfoService) { }
  ngOnChanges() {
    if (this.key !== undefined && this.key !== null && this.key !== '') {
      this.selectedOperator = this.operatorList.find(el => el.key === this.key);
      const t = { ...this.selectedOperator };
      if (t.key) {
        document.getElementById('operatorId').classList.remove('hide_selected');
        document.getElementById('operatorId').classList.add('focused');
        this.operatorNameString.emit(t);
      } else {
        this.diableOperator.emit();
      }
    } else {
      this.selectedOperator = { key: '' };
    }
  }
  ngOnInit() {
    document.getElementById('operatorId').classList.add('hide_selected');
    this.getOperators();
  }
  getOperators() {
    let operatorList = JSON.parse(sessionStorage.getItem('operatorLi'));
    if (operatorList === null) {
      this.baseInfo.getMobileOperators()
        .subscribe(
          res => {
            if (res.code === 0) {
              operatorList = res.content.operators;
              operatorList = operatorList.filter(
                x => x.nameFa === 'رایتل' || x.nameFa === 'ایرانسل' || x.nameFa === 'همراه اول');
              sessionStorage.setItem('operatorLi', JSON.stringify(operatorList));
              this.doStuff();
            }
          }
        );
    } else {
      this.doStuff();
    }
  }
  sendOperatorName() {
    document.getElementById('operatorId').classList.add('focused');
    this.operatorNameString.emit(this.selectedOperator);
  }
  selectFirst() {
    document.getElementById('operatorId').classList.remove('hide_selected');
    if (this.operatorList.length > 0 && this.selectedOperator && this.selectedOperator.key === '') {
      document.getElementById('operatorId').classList.add('focused');
      this.selectedOperator = this.operatorList[0];
      this.operatorNameString.emit(this.selectedOperator);
    }
  }
  doStuff() {
    this.getAllPrices();
    // if (this.key !== undefined && this.key !== null && this.key !== '') {
    //   document.getElementById('operatorId').classList.remove('hide_selected');
    //   document.getElementById('operatorId').classList.add('focused');
    //   this.selectedOperator = this.operatorList.find(el => el.key === this.key);
    //   const t = { ...this.selectedOperator };
    //   this.operatorNameString.emit(t);
    // }
  }
  getAllPrices() {
    const operatorList = JSON.parse(sessionStorage.getItem('operatorLi'));
    if (!operatorList[0].topUpTypes) {
      this.baseInfo.getImPrices().subscribe(
        res => {
          if (res.code === 0) {
            const enabletopUp = JSON.parse(sessionStorage.getItem('enabletopUp'));
            res.content.forEach(element => {
              const index = operatorList.findIndex(x => x.key === element.mobileOperatorKey);
              if (index !== -1) {
                operatorList[index].topUpTypes = [];
                element.topups.forEach(type => {
                  const t = enabletopUp.find(el => (el.mobileOperatorKey.toLowerCase() === element.mobileOperatorKey.toLowerCase()
                    && type.topupTypeNameEn.toLowerCase() === el.topupType.toLowerCase()));
                  if (t.enabled) {
                    operatorList[index].topUpTypes.push(type);
                  }
                });
              }
            });

            operatorList.forEach(element => {
              if (element.topUpTypes.length > 0) {
                this.operatorList.push(element);
              }
            });
            sessionStorage.setItem('operatorLi', JSON.stringify(this.operatorList));
            this.setSelectedOperator();
          }
        }
      );
    } else {
      operatorList.forEach(element => {
        if (element.topUpTypes.length > 0) {
          this.operatorList.push(element);
        }
      });
      this.setSelectedOperator();
    }
  }
  setSelectedOperator() {
    this.operatorLists.emit(this.operatorList);
    if (this.key !== undefined && this.key !== null && this.key !== '') {
      document.getElementById('operatorId').classList.remove('hide_selected');
      document.getElementById('operatorId').classList.add('focused');
      this.selectedOperator = this.operatorList.find(el => el.key === this.key);
      const t = { ...this.selectedOperator };
      this.operatorNameString.emit(t);
    }
  }
}
